export interface IWebsocketOptions {
  protocol?: "ws:" | "wss:";
  hostname?: string;
  port?: number;
  endpoint?: string;
  flightDeckToken?: string;
  onError?: (error: Error) => void;
}

export const getPort = () => {
  if (window?.location?.port) {
    let port: number | undefined;

    port = parseInt(window?.location?.port, 10);

    if (!isNaN(port)) {
      return port;
    }
  }

  if (window?.location?.protocol === "http:") {
    return 80;
  } else if (window?.location?.protocol === "https:") {
    return 443;
  }

  return 80; // guess 80 if nothing else works
};

const getDefaultWsProtocol = (port: number) => {
  if (port === 80) {
    return "ws:";
  } else if (port === 443) {
    return "wss:";
  }

  return "ws:";
};

export const getHostname = () => {
  return window?.location?.hostname;
};

/**
 * Returns a URI for a websocket hosted on the same server/nginx
 * as this is running
 */
export const getWebsocketUri = (options?: IWebsocketOptions) => {
  if (!options) {
    options = {};
  }

  const port = options.port || getPort();
  const hostname = options.hostname || getHostname();
  const protocol = options.protocol || getDefaultWsProtocol(port);
  let endpoint = options.endpoint || "";

  if (!endpoint.startsWith("/")) {
    endpoint = `/${endpoint}`;
  }

  let maybePort = "";
  if (port !== 80 && port !== 443) {
    maybePort = `:${port}`;
  }

  let maybeAuthToken = "";
  if (options.flightDeckToken) {
    if (options.endpoint && options.endpoint.indexOf("?") > -1) {
      // if endpoint already has query params
      maybeAuthToken = `&auth_token=${options.flightDeckToken}`;
    } else {
      maybeAuthToken = `?auth_token=${options.flightDeckToken}`;
    }
  }

  return `${protocol}//${hostname}${maybePort}${endpoint}${maybeAuthToken}`;
};
